import React from 'react';
import Product from "components/partials/product";
import {Products} from "api";

class FairListProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 10,
      order: "id DESC"
    }
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order,
        where: {
          isIndustryFeatured: true
        }
      }
    };
    Products.actions.list.request(params).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  render() {
    return (
      <div className="fair-list-product-container">
        <h2 className='fair-list-product-title'><span className='title-content'>{this.props.title}</span></h2>
        <div className='fair-list-product'>
          {
            this.state.data.map((item, i) => {
              return (
                <Product
                key={i}
                {...item}
                enableSendRequest={false}
                enableAddProduct={true}
                showFairSalePrice={true}
                showPrice={false}
                fixHeightContent = {true}
                />
              );
            })
          }
        </div>
      </div>
    );
  }
}

export default FairListProduct;


// WEBPACK FOOTER //
// ./components/fair/sub-view/list/FairListProduct.jsx